/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
import { forwardRef, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */
import Fill from './fill';
import BaseSlot from './slot';
import BubblesVirtuallySlot from './bubbles-virtually/slot';
import SlotFillProvider from './provider';
import SlotFillContext from './context';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export { default as useSlot } from './bubbles-virtually/use-slot';
export { default as useSlotFills } from './bubbles-virtually/use-slot-fills';
export { Fill };
export const Slot = forwardRef((props, ref) => {
  const {
    bubblesVirtually,
    ...restProps
  } = props;
  if (bubblesVirtually) {
    return /*#__PURE__*/_jsx(BubblesVirtuallySlot, {
      ...restProps,
      ref: ref
    });
  }
  return /*#__PURE__*/_jsx(BaseSlot, {
    ...restProps
  });
});
Slot.displayName = 'Slot';
export function Provider({
  children,
  passthrough = false
}) {
  const parent = useContext(SlotFillContext);
  if (!parent.isDefault && passthrough) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(SlotFillProvider, {
    children: children
  });
}
Provider.displayName = 'SlotFillProvider';
export function createSlotFill(key) {
  const baseName = typeof key === 'symbol' ? key.description : key;
  const FillComponent = props => /*#__PURE__*/_jsx(Fill, {
    name: key,
    ...props
  });
  FillComponent.displayName = `${baseName}Fill`;

  // Wrap SlotComponent with forwardRef to support ref forwarding
  const SlotComponent = forwardRef((props, ref) => /*#__PURE__*/_jsx(Slot, {
    name: key,
    ref: ref,
    ...props
  }));
  SlotComponent.displayName = `${baseName}Slot`;
  /**
   * @deprecated 6.8.0
   * Please use `slotFill.name` instead of `slotFill.Slot.__unstableName`.
   */
  SlotComponent.__unstableName = key;
  return {
    name: key,
    Fill: FillComponent,
    Slot: SlotComponent
  };
}